<select appFormInput
        *ngIf="offices$ | async as offices"
        [(ngModel)]="selectedOffice">
  <option [ngValue]="null">{{ 'ContactForm.DefaultOfficeSelectOption' | translate }}</option>
  <option [ngValue]="office" *ngFor="let office of offices">
    {{ office.location.city.name }}, {{ office.address }}
  </option>
</select>
